import request from "@/api/request";

export function getRoutes() {
    return request({
        url: '/api/getRoutes',
        method: 'get'
    })
}

export default {getRoutes}
